import CardPerson from "../CardPerson/CardPerson";
import CardsList from "../UI/CardsList/CardsList";

const List = (props) => {
  let content;

  const items = props.items;
  const isFiltered = props.isFiltered;

  content = (
    <CardsList>
      {items.map((item, i) => {
        if (i < 3 && !isFiltered) {
          return (
            <>
              <h2 className="Heading">#{i + 1}</h2>
              <CardPerson person={item} key={item.id} position={i + 1} />
            </>
          );
        } else {
          return <CardPerson person={item} key={item.id} position={i + 1} />;
        }
      })}
    </CardsList>
  );
  return content;
};

export default List;
